import React, { useEffect, useRef, useState } from 'react';
import { Eyebrow } from '../ui';

const pills = [
  { label: 'Travel', active: true }, { label: 'Festivals', active: false },
  { label: 'Movies', active: true }, { label: 'Books', active: false },
  { label: 'Writers', active: false }, { label: 'Hollywood', active: true },
  { label: 'Fashion', active: false }, { label: 'Coffee', active: true },
  { label: 'Dog lover', active: false }, { label: 'Chatting', active: true },
  { label: 'Hiking', active: true }, { label: 'Swimming', active: false },
  { label: 'Music', active: true }, { label: 'Food', active: false },
  { label: 'Yoga', active: false }, { label: 'Football', active: true },
  { label: 'Church', active: false }, { label: 'Road trips', active: true },
  { label: 'Lifestyle', active: true }, { label: 'Astrology', active: false },
];

export default function Interests() {
  const cloudRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = cloudRef.current; if (!el) return;
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setVisible(true); obs.unobserve(el); } }, { threshold: 0.2 });
    obs.observe(el); return () => obs.disconnect();
  }, []);

  return (
    <section className="py-16 lg:py-[100px] px-[5%] text-center" id="interests">
      <Eyebrow>Your vibe</Eyebrow>
      <h2 className="text-[clamp(28px,4vw,44px)] font-bold tracking-[-1.2px] mb-4">Connect around shared interests</h2>
      <p className="text-[17px] text-muted max-w-[500px] mx-auto leading-relaxed mb-8 lg:mb-12">
        Pick up to 10 interests. We use them to surface people who share your world.
      </p>
      <div ref={cloudRef} className="flex flex-wrap gap-3 justify-center max-w-[700px] mx-auto">
        {pills.map((p, i) => (
          <span
            key={p.label}
            className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200 hover:scale-105 cursor-default ${
              p.active
                ? 'bg-black text-white'
                : 'bg-white text-black border border-[#d8c8cf] hover:bg-black hover:text-white hover:border-black'
            }`}
            style={visible ? { animation: `pillBounce 0.5s cubic-bezier(0.22,1,0.36,1) ${i * 60}ms forwards` } : { opacity: 0 }}
          >
            {p.label}
          </span>
        ))}
      </div>
    </section>
  );
}
